var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3623 7.85011V15.9484C19.3971 16.5431 19.2012 17.1278 18.8172 17.5752C18.4333 18.0226 17.8924 18.2964 17.3123 18.3372H2.69359C2.11353 18.2964 1.57266 18.0226 1.18872 17.5752C0.804781 17.1278 0.608853 16.5431 0.64359 15.9484V7.85011",
    stroke: "#757575",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84966 0.121711L7.74185 3.11092L5.73091 5.95924C5.69951 6.00373 5.68073 6.05625 5.67663 6.111C5.67254 6.16574 5.68329 6.22058 5.7077 6.26945C5.73212 6.31833 5.76924 6.35933 5.81497 6.38794C5.86071 6.41655 5.91327 6.43165 5.96685 6.43156H8.65591V14.8196H11.5044V6.43156H14.195C14.2486 6.43165 14.3011 6.41655 14.3469 6.38794C14.3926 6.35933 14.4297 6.31833 14.4541 6.26945C14.4785 6.22058 14.4893 6.16574 14.4852 6.111C14.4811 6.05625 14.4623 6.00373 14.4309 5.95924L12.4262 3.11092L10.3184 0.121711C10.2914 0.0839877 10.2561 0.0533104 10.2154 0.0321648C10.1747 0.0110192 10.1297 0 10.084 0C10.0384 0 9.99338 0.0110192 9.95266 0.0321648C9.91194 0.0533104 9.87666 0.0839877 9.84966 0.121711Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b01ee7ab126d09da43daec2e52ac33b3.svg";
export { ForwardRef as ReactComponent };